import { Content, IContentInfo, useOperation } from "@eusoft/webapp-ui";
import { Template, forModel } from "@eusoft/webapp-jsx";
import { SongViewHost } from "../components/SongViewHost";
import { Toolbar } from "../components/Toolbar";
import { controls } from "../services/Controls";
import "./MainPage.scss";
import { userInteraction } from "@eusoft/webapp-framework/services/UserInteraction";

export class MainPage extends Content {

    constructor() {

        super();

        this.init(MainPage, {
            title: "VocalCoach",
            style: [],
            body: forModel(this, m => <Template name="MainPage">
                <main>
                    <SongViewHost ref={m.songViewHost} />
                    <Toolbar ref={m.toolbar} />
                </main>
            </Template>)
        });
    }

    override mount(ctx) {

        super.mount(ctx);

        this.initAsync();

    }

    protected async initAsync() {

        await this.checkPermissionsAsync();

        controls.attachView(this.songViewHost.songView);

        controls.addEventListener("stateChanged", () => {
            const state = controls.getState();
            localStorage.setItem("controls", JSON.stringify(state));
        });

        const jsonState = localStorage.getItem("controls");
        if (jsonState)
            await controls.setStateAsync(JSON.parse(jsonState));
        else
            await controls.setDefaultStateAsync();

        await this.toolbar.loadAsync();

        this.test();

        //startCalibrateAsync();

        return true;
    }

    protected async checkPermissionsAsync() {

        if (localStorage.getItem("permissions") != "true") {

            const res = await userInteraction.messageBoxAsync(
                <span>Prima di procedere, è necessario richiedere alcuni permessi.</span>,
                "Conferma permessi",
                {
                    "confirm": {
                        label: "Conferma",                        
                    }
                }
            );

            if (res == "confirm") {

                await useOperation(async () => {

                    await navigator.requestMIDIAccess({
                        software: true,
                        sysex: true
                    });

                    await navigator.mediaDevices.getUserMedia({ video: false, audio: true });

                    localStorage.setItem("permissions", "true");

                    return true;
                });
            }
        }
    }

    async test() {

        const songView = controls.songView;

        await controls.loadSongByUrlAsync("http://" + location.host + "/media/when_i_come_around.mid", 4);

        songView.origin = { x: 9.2, y: Math.log2(100) };


        /*

        const data = JSON.parse(localStorage.getItem("last-data")) as IPitchValue[];

        const filter1 = new PitchFilter2();
        const filter2 = new PeackRemove();
        const rawData2: IPitchValue[] = [];

        songView.beginUpdate();

        data.forEach(a => {
            //a = filter1.processSample(a);
            a = filter2.processSample(a);
            a = filter2.processSample(a);
            rawData2.push(a);
            songView.addPitch(a.time, a.pitch, a.power);
        });

        const valid = data.find(a => a.pitch != null);

        songView.origin = { x: valid.time + 50, y: Math.log2(valid.pitch) };
        songView.pixelPerSeconds = 10;
        songView.pixelPerHertz = 70;
        songView.endUpdate();
        */
    }

    songViewHost: SongViewHost;

    toolbar: Toolbar;

    static override info = {
        name: "home",
        route: "/",
        factory: () => new MainPage()
    } as IContentInfo;
}
